import React from 'react';
import { useSelector } from 'react-redux';
import Panel from '../Panel.js';
import PerformedBy from '../performed-by/PerformedBy.js';
import HistItem from './HistItem.js';
const TribunalCaseItem = ({ date, data }) => {
    const lang = useSelector((s) => s.lang);
    const detail = [lang.tribunalCaseTypes[data.type], data.reference]
        .filter(Boolean)
        .join(' · ');
    return (React.createElement(HistItem, { date: date, heading: React.createElement("div", null,
            data.createdBy && (React.createElement("span", { style: { marginRight: '0.5em' } },
                React.createElement(PerformedBy, { performedBy: data.createdBy }))),
            lang.history.tribunalCaseCreated) }, detail && React.createElement(Panel, null, detail)));
};
export default TribunalCaseItem;
//# sourceMappingURL=TribunalCaseItem.js.map